import { CommentModel } from 'models/CommentModel';

import { ApiRouteService } from '../services';
import { HttpRequestOptionsType } from '../types';
import { DataResult } from '../types';
import { HttpClient } from './HttpClient';

export class CommentClient {
  private readonly httpClient: HttpClient;
  private readonly baseUrl = `${ApiRouteService.getCompumedApiBaseRoute()}/api/Comments`;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
    this.getComments = this.getComments.bind(this);
  }

  public async getComments(entityType: string, entityId: number) {
    const options = await this.httpClient.createStandardOptions('GET', null);
    const request = fetch(`${this.baseUrl}/${entityType}/${entityId}`, options);
    const result = await this.httpClient.fetchAndParse<DataResult<CommentModel>>(request);
    return result.data;
  }

  public async postComment(
    commentData: Omit<CommentModel, 'id' | 'userName' | 'timestamp' | 'userId'>,
    options?: HttpRequestOptionsType,
  ): Promise<CommentModel> {
    const requestOptions = await this.httpClient.createStandardOptions('POST', commentData, options);
    const request = fetch(this.baseUrl, requestOptions);
    return this.httpClient.fetchAndParse<CommentModel>(request);
  }
}
